import React from "react";

import classnames from "classnames";
import { withStyleProps } from "Utils/styleProps";

import { TitleSmall } from "Cobalt/Header";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";
import type { CardProps, CardSubcomponentProps } from "Theme/Card";

import makeBem from "Utils/makeBem";

export const bem = makeBem("Card");

/**
A Card is the most basic visual layout tool. The default Card should be
used most of the time. It has sane defaults for padding and margins, and
is full-width.
* */
const BaseCard = ({ theme = "elevated", className, ...rest }: CardProps) => {
  return <div className={classnames(bem(), className, bem(null, theme))} {...rest} />;
};

const Card = withStyleProps(BaseCard, { mb: 4, p: 4 });

// No idea why this is complaining, has to do with SectionProps
// being read-only, but being used as write-only deeper in the stack?
// @ts-expect-error
let CardSection = ({ className, ...rest }: CardSubcomponentProps) => <div className={classnames(className, bem("Section"))} {...rest} />;

CardSection = withStyleProps(CardSection, {
  p: 4,
});
export { Card, CardSection };
export const CardHeader = ({ children, className, ...rest }: CardSubcomponentProps) => {
  return (
    <CardSection className={className} {...rest}>
      <TitleSmall mt={0} mb={0}>
        {children}
      </TitleSmall>
    </CardSection>
  );
};
export const CardSeparator = ({ className, ...rest }: any) => (
  <Div mb={4} className={classnames(bem("Separator"), className)} {...rest}>
    <Icon icon="circle" aria-hidden="true" />
    <Icon icon="circle" aria-hidden="true" />
    <Icon icon="circle" aria-hidden="true" />
  </Div>
);
export const CardFooter = ({ children, className, ...rest }: CardSubcomponentProps) => (
  <Div className={classnames(bem("Footer"), className)} p={4} {...rest}>
    {children}
  </Div>
);
